import React from "react";
import { Spinner as Spinners } from "@chakra-ui/react";
import { theme } from "src/styles/theme";

const Spinner = () => {
  return <Spinners color={theme.primary} />;
};

export default Spinner;
